import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function AddBoxIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="currentColor" viewBox="0 0 24 24" {...props}>
      <Box as="path" d="M11 8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8Z" />
      <Box
        as="path"
        fillRule="evenodd"
        d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
